import React from 'react';
import { Text } from 'react-native';
import { useQuery } from '@apollo/client';
import styled from 'styled-components/native';

import DataState from 'app/src/components/DataState';
import { PageTitle, CardContainer } from 'app/src/elements';
import { currency } from 'app/src/utils/stringHelpers';

import { Card } from 'app/src/elements';

import { STATS } from './queries';

const Label = styled(Text)`
  font-weight: 600;
  text-align: center;
`;

const Value = styled(Text)`
  font-weight: 600;
  text-align: center;
  font-size: 20px;
  color: green;
`;

const Stats = () => {
  const { loading, data } = useQuery(STATS);

  return (
    <>
      <PageTitle>Stats</PageTitle>
      {loading ? (
        <DataState.Loading />
      ) : (
        <CardContainer style={{maxHeight: 260, minHeight: 260}}>
          <Card>
            <Label>Assets in upcoming sales</Label>
            <Value>{data.stats.assetsUpcoming}</Value>
          </Card>
          <Card>
            <Label>Assets sold in last {data.stats.days} days</Label>
            <Value>{data.stats.assetsSoldCount}</Value>
          </Card>
          <Card>
            <Label>Average sale price in last {data.stats.days} days</Label>
            <Value>{currency(data.stats.assetsSoldPrice)}</Value>
          </Card>
        </CardContainer>
      )}
    </>
  );
};

export default Stats;
